import { AnalyticsProductDto } from "@intelligems/ig-types/dtos/analytics-products";
import { ExperienceProductDto } from "@intelligems/ig-types/dtos/experience-products";

import { fromGqlId } from "./shopify";

export function testProductsFromGqlId<
  T extends ExperienceProductDto | AnalyticsProductDto,
>(testProducts: T[]) {
  return testProducts.map((product) => {
    return { ...product, id: fromGqlId(product.id) };
  });
}
